import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import { updateCustomer } from "../../services/customerService";

const UpdateCustomerModal = ({ visible, customer, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && customer) {
      form.setFieldsValue({
        companyName: customer.companyName,
        phone: customer.phone,
        contactPerson: customer.contactPerson,
      });
    }
  }, [visible, customer, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const currentUserId = localStorage.getItem("userId");
      const customerData = {
        ...values,
        updatedByUserId: currentUserId
      };

      await updateCustomer(customer.id, customerData);
      onSuccess();
    } catch (error) {
      if (error.errorFields) {
        // Form validation error
      } else {
        message.error("Failed to update customer");
        console.error("Error updating customer:", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Müşteri Düzenle"
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          İptal
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
        >
          Güncelle
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="companyName"
          label="Müşteri Adı"
          rules={[
            { max: 100, message: "Müşteri ismi 100 karakteri geçemez" },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Numara"
          rules={[
            {
              pattern: /^0\d{3} \d{3} \d{4}$/,
              message: "Numara 0XXX XXX XXXX formatında olmalı",
            },
          ]}
        >
          <Input
            placeholder="0XXX XXX XXXX"
            maxLength={13}
            onKeyPress={(e) => {
              const allowedChars = /[0-9 ]/;
              if (!allowedChars.test(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>

        <Form.Item
          name="contactPerson"
          label="İlgili Kişi"
          rules={[
            { max: 100, message: "İlgili kişi alanı 100 karakteri geçemez" },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateCustomerModal;
